"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var react_router_1 = require("react-router");

var use_force_update_1 = require("use-force-update");

var useRouter = function useRouter() {
  var forceUpdate = use_force_update_1.default();
  var routerContext = react_1.useContext(react_router_1.__RouterContext);

  if (!routerContext) {
    throw new Error('use-react-router may only be used within a react-router context.');
  }

  react_1.useEffect(function () {
    return routerContext.history.listen(forceUpdate);
  }, [routerContext]);
  return routerContext;
};

exports.default = useRouter;